export default {"src":"/_next/static/media/TastingPanel.f84c7e78.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};